import React from "react";
import { AutocompleteInput, Filter, ReferenceInput, useTranslate } from "react-admin";

import { DateTimeInput, NumberInputEx } from "components/inputs";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import TextInputEx from "components/_extensions/react-admin/input/TextInputEx";
import { StorageContextType } from "entities/StorageContextType";
import { StorageTransactionDirection } from "entities/StorageTransactionDirection";

export const StorageTransactionsFilters = (props) => {
	const translate = useTranslate();
	const t = (source) => translate(`resources.storage-transactions.fields.${source}`);

	return (
		<Filter {...props}>
			<SelectEnumInput
				source="direction"
				enumObj={StorageTransactionDirection}
				enumName="storage_transaction_direction"
				resettable
			/>
			<NumberInputEx source="storage_context_id" />
			<NumberInputEx source="storage_entity_id" />
			<NumberInputEx source="storage_place_id" />
			<DateTimeInput source="timestamp:gte" label={t("timestamp_gte")} />
			<DateTimeInput source="timestamp:lte" label={t("timestamp_lte")} />
			<DateTimeInput source="planned_timestamp:gte" label={t("planned_timestamp_gte")} />
			<DateTimeInput source="planned_timestamp:lte" label={t("planned_timestamp_lte")} />
			<DateTimeInput source="modified_at:gte" label={t("modified_at_gte")} />
			<DateTimeInput source="modified_at:lte" label={t("modified_at_lte")} />
			<ReferenceInput
				source="modified_by"
				label={t("modified_by")}
				reference="users"
				sort={{ field: "full_name", order: "ASC" }}
				filter={{ no_range: true }}
			>
				<AutocompleteInput optionText="full_name" debounce={500} resettable />
			</ReferenceInput>
			<SelectEnumInput
				source="storage_context_type"
				enumObj={StorageContextType}
				enumName="storage_context_type"
				resettable
			/>
			<TextInputEx source="storage_place_address" />
			<NumberInputEx source="storage_entity_pallet_id" alwaysOn />
			<TextInputEx source="storage_entity_pallet_sscc" alwaysOn />
			<TextInputEx source="storage_entity_pallet_sscc_original" />
			<NumberInputEx source="storage_entity_pallet_ext_id" alwaysOn />
			<TextInputEx source="storage_entity_pallet_ceel_number" />
			<NumberInputEx source="storage_context_order_id" alwaysOn />
			<TextInputEx source="storage_context_order_reference" />
			<NumberInputEx source="storage_context_order_deviation_id" />
			<NumberInputEx source="storage_context_task_id" />
		</Filter>
	);
};
